import axios from "axios"

const api_url = process.env.REACT_APP_API_URL

export const handlePostApi = async (url, data, headers = {}) => {
    try{
        const res = await axios.post(`${api_url}${url}`, data, {headers})
        return res.data
    } catch(err){
        return err.response.data
    }
}

export const handleGetApi = async (url, headers = {}) => {
    try{
        const res = await axios.get(`${api_url}${url}`, {headers: headers})
        return res.data
    } catch(err){
        return err.response.data
    }
}